import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';

const alertVariants = cva('relative flex w-full gap-3 rounded-lg border px-4 py-3 text-sm [&>svg]:mt-0.5 [&>svg]:size-4 [&>svg]:shrink-0', {
  variants: {
    variant: {
      default: 'bg-card text-card-foreground',
      info: 'border-info/30 bg-info-subtle text-info-subtle-foreground',
      success: 'border-success/30 bg-success-subtle text-success-subtle-foreground',
      warning: 'border-warning/40 bg-warning-subtle text-warning-subtle-foreground',
      destructive: 'border-destructive/30 bg-destructive-subtle text-destructive-subtle-foreground',
    },
  },
  defaultVariants: { variant: 'default' },
});

/** @param {import('react').ComponentProps<'div'> & { variant?: 'default'|'info'|'success'|'warning'|'destructive' }} props */
export function Alert({ className, variant, role, ...props }) {
  return (
    <div data-slot="alert" role={role ?? (variant === 'destructive' ? 'alert' : 'status')} className={cn(alertVariants({ variant }), className)} {...props} />
  );
}

/** @param {import('react').ComponentProps<'div'>} props */
export function AlertTitle({ className, ...props }) {
  return <div data-slot="alert-title" className={cn('font-medium', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'div'>} props */
export function AlertDescription({ className, ...props }) {
  return <div data-slot="alert-description" className={cn('text-sm opacity-90', className)} {...props} />;
}
